import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getRentalPeriods } from '../propertyEndpoints'

/** GET /admin/properties/:propertyId/rental-periods — lease history list. */
export function useRentalPeriodsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.rentalPeriods(toValue(id)),
    queryFn: () => getRentalPeriods(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
